class ModalController {
  /* @ngInject */
  constructor() {
    const that = this;

    that.idDialog = that.idvalue;

    that.confirmFunction = () => {
      that.confirm();
    };

    that.closeFunction = () => {
      that.close();
    };
  }
}

export default ModalController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/modal/modal.controller.js
 **/